import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";
import { useThemeSettings } from "../../../ThemeProvider";
import { useTranslation } from "react-i18next";
import ThinkOLogo from "../../../components/ThinkoLogo";


const ChatbotHeader: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const { theme } = useThemeSettings();
    const { t } = useTranslation();

    return (
            <View style={styles.container}>
                {/* Left section: Logo + Labels */}
                <View style={styles.leftWrap}>

                    <ThinkOLogo size={42} />

                    <View style={styles.textWrap}>
                        <Text style={[styles.title, { color: theme?.colors?.primary }]}>
                            {t('screens.assistant.chatbotTitle')}
                        </Text>
                        <Text style={[styles.subtitle, { color: theme?.colors?.secondary }]}>
                            {t('screens.assistant.chatbotSubtitle')}
                        </Text>
                    </View>
                </View>

                {/* Close Button */}
                <TouchableOpacity
                    onPress={onClose}
                    style={styles.closeButton}
                    hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
                >
                    <View style={[styles.closeCircle, { borderColor: theme?.colors?.primary }]}>
                        <Text style={[styles.closeText, { color: theme?.colors?.primary }]}>
                            ✕
                        </Text>
                    </View>
                </TouchableOpacity>
            </View>
    );
};

export default ChatbotHeader;

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        borderRadius: 24,
    },

    leftWrap: {
        flexDirection: "row",
        alignItems: "center",
    },

    textWrap: {
        marginLeft: 16,
    },

    logo: {
        width: 42,
        height: 42,
        backgroundColor: 'gray',
    },

    title: {
        color: "#7A3C3C", // matches your style
        fontSize: 18
    },

    subtitle: {
        color: "#7A3C3C",
        fontSize: 14
    },

    closeButton: {
        paddingLeft: 12,
    },

    closeCircle: {
        width: 30,
        height: 30,
        borderRadius: 15,
        borderWidth: 2,
        justifyContent: "center",
        alignItems: "center",
    },

    closeText: {
        fontSize: 14,
        fontWeight: "900",
    },
});